<template>
  <div id="app">
    <router-view v-on:open-popup="openPopup"></router-view>
    <update-structure-popup ref="update-structure"></update-structure-popup>
  </div>
</template>

<script>
import UpdateStructurePopup from "./components/Popups/UpdateStructurePopup";
export default {
  name: 'app',
  components: {
    UpdateStructurePopup,
  },
  methods: {
    openPopup: function (data) {
      this.$refs[data.name].open(data);
    }
  }
}
</script>

<style>
</style>
